import React from 'react';
import { Form, FormGrid, LoadingIndicator, OccupyFreeSpace, SaveButton, useSaveable } from '../../../toolympus/components/primitives';
import { useB24IntegrationSettings } from './useB24IntegrationSettings';
import { FormControlsForFields } from '../../../toolympus/components/schemed';
import { Button } from '@mui/material';

interface Props {
  
}

export const B24IntegrationSettingsPage = (props: Props) => {
  const data = useB24IntegrationSettings();
  useSaveable(data);
  
  return (
    <Form
      title="Настройки интеграции Б24"
      headerItems={<>
        <OccupyFreeSpace />
        {!!data.isLoading && <LoadingIndicator sizeVariant="s" />}
        {!!data.hasChanges && <SaveButton action={() => data.save()} />}
        <Button size="small" onClick={() => data.getConfRooms.run()}>получить переговорки Б24</Button>
      </>}>

      <FormGrid>
        <FormGrid noMargin columns="300px">

          <FormControlsForFields
            data={data.settings}
            onChange={(o,c) => data.update(c)}
            fields={[
              ["b24_domain"],
              ["inbound_webhook_token"],
              ["outbound_webhook_address"],
              ["integration_pass_code"],
              ["confroom_link_text"],
              ["b24_approval_log_properties"],
            ]}
            schema={data.schema}
            />
        </FormGrid>

        <div />

        <div>
          {!!data.getConfRooms.isRunning && <LoadingIndicator />}
          {!!data.confroomsList?.length &&
            data.confroomsList.map(cr => (
              <p key={cr.ID}>{cr.ID}: {cr.NAME} ({cr.CAL_TYPE})</p>
            ))}
        </div>
        
      </FormGrid>
    </Form>
  );
}
